import { Component, OnInit } from '@angular/core';
import {
  EtopsConfiguration,
  FlightEtops,
} from '@app/flight-planning/flight-plan-constant';
import { FlightPlanService } from '@app/flight-planning/route-plan/services/flight-plan.service';
import { Events } from '@app/shared/services/events.service';
@Component({
    selector: 'app-edto',
    templateUrl: './edto.component.html',
    styleUrls: ['./edto.component.scss'],
    standalone: false
})
export class EdtoComponent implements OnInit {
  public disableOption: boolean = false;
  constructor(public flightPlanService: FlightPlanService, private events: Events) { }

  public ngOnInit() { }
  public openAccordian() {
    this.flightPlanService.accordionSwitch('flightplanetop');
  }
  public toggleEtops() {
    this.flightPlanService.etpConfiguration.etopsMethod == "Manualetops" ? this.disableOption = true : this.disableOption = false;
  }
  public createETPPairs() {
    if (this.flightPlanService.etpConfiguration.etpMethod == "auto") {
      this.flightPlanService.etpConfiguration.etpAirportList = this.chunks(this.flightPlanService.etpConfiguration.adequate);
    } else {
      this.flightPlanService.etpConfiguration.etpAirportList = [];
    }
  }
  private chunks(arr, size = 2) {
    return arr.map((x, i) => i % size == 0 && arr.slice(i, i + size)).filter((x) => x);
  }
  private oddOrEven(x: number) {
    return (x && 1) ? "odd" : "even";
  }
  public removeEtpPairs(index: number) {
    this.flightPlanService.etpConfiguration.etpAirportList.splice(index, 1);
    this.flightPlanService.etpConfiguration.etpAirportList.toarray();
    if (this.flightPlanService.etpConfiguration.etpAirportList[index - 1]) {
      this.flightPlanService.etpConfiguration.etpStart = this.flightPlanService.etpConfiguration.etpAirportList[index - 1][1];
    }
  }
  public addEtpPair(etpStart: string, etpEnd: string) {
    this.flightPlanService.etpConfiguration.etpAirportList.push([etpStart.toUpperCase(), etpEnd.toUpperCase()]);
    this.flightPlanService.etpConfiguration.etpStart = etpEnd;
    this.flightPlanService.etpConfiguration.etpEnd = "";
  }
  public checkAirportSuitable(ICAOCode: string) {
    const result = this.flightPlanService.tripRouteData.AdequateAirport.filter((airport) => {
      return airport.EtopsType == "ETOPSSuitableAirport" && airport.ICAOCode == ICAOCode;
    });
    return result.length > 0 ? true : false;
  }
  public showlistOfAdequateAirport() {
  }
  public emitEvent(event:any) {
    this.events.publish(
      "etopOnInput",
      event
    );
  }
}
